import { reactive } from "vue";

export const state = reactive({
    domain: import.meta.env.MODE === "development" ? "vactar.si" : import.meta.env.MODE === "staging" ? "vactar.dev" : "vactar.app",
    plugins: {},
    lastRoute: undefined
});
